import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMobxInstance } from '@client/clientUtils/mobxUtil';
import { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

class ViewStore {
    selectedBirthYear: number | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setBirthYear = (year: number | null) => {
        this.selectedBirthYear = year;
    };

    /**
     * 생년 옵션 목록 생성 (14세~80세)
     */
    get birthYearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let age = 14; age <= 80; age++) {
            years.push(currentYear - age);
        }

        return years.sort((a, b) => b - a); // 최신년도부터
    }

    /**
     * 기본값 설정 (35세)
     */
    setDefault = () => {
        const currentYear = new Date().getFullYear();
        this.selectedBirthYear = currentYear - 35; // 30세
    };
}

const BirthYearInput = observer(
    ({
        value,
        onChange,
        className,
        placeholder = '태어난 해를 선택해주세요',
    }: {
        value?: number | null;
        onChange?: (year: number) => void;
        className?: string;
        placeholder?: string;
    }) => {
        const viewStore = useMobxInstance(ViewStore);

        useEffect(() => {
            viewStore.setBirthYear(value || null);
        }, [value]);

        const handleChange = (year: number) => {
            viewStore.setBirthYear(year);
            onChange?.(year);
        };

        return (
            <select
                className={twMerge('select select-lg w-full', className)}
                value={viewStore.selectedBirthYear || ''}
                onChange={(e) => {
                    const year = parseInt(e.target.value);
                    if (!isNaN(year)) {
                        handleChange(year);
                    }
                }}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {viewStore.birthYearOptions.map((year) => (
                    <option key={year} value={year}>
                        {year}년
                    </option>
                ))}
            </select>
        );
    },
);

export default BirthYearInput;
